import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingsService } from './settings.service';
import { User } from '../dashboard/models/user';
import { Observable } from 'rxjs';
import { LoginResponse } from '../auth/interfaces/login-response';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private http: HttpClient,
    private settingService: SettingsService,
    private router: Router
  ) {

    this.currentUser = new User();
  }

  public currentUser: User;

  public logout():void {

    this.currentUser = new User();
    
  }

  public login(email:string, password:string): Observable<LoginResponse>
  {

      let requestUrl: string = 
        "http://131.153.202.191:30036/authenticate";
      
      let requestData =
        {email: email, password: password };

      return this.http.post<LoginResponse>
        (requestUrl,requestData, this.settingService.httpOptions).pipe();
          
  }

  hasAuthenticate(): boolean {
    if (!this.currentUser) {
      this.router.navigateByUrl('/notauthorized');
      return false;
    }

    return true;
  }
}
